module.exports = __webpack_public_path__ + "media/src/images/lady-in-cafe-p-1080x607-9e9717ef368a1636ff03be81d53b01ef.jpeg";